import React, {useContext} from "react";
import PropTypes from "prop-types";
import {View, Text} from "@react-pdf/renderer";

import PrintSimilarProductsListItem from "./printSimilarProductsListItem";
import {PrintDocumentContext} from "../printDocumentContext";
import {getFeaturesCollectionsList} from "../../../shoppingCart/similarProducts/similarProductsFunctions";

const PrintSimilarProducts = (props) => {

  const {styles, cartItems, fabricatorData, filterGroups, locale, quoteIndex} = props;
  const similarOpened = true;
  const printContext = useContext(PrintDocumentContext);

  const insideQuote = Number.isInteger(quoteIndex);

  const addedCountertops = insideQuote
    ? cartItems.filter(cItem => cItem.currentQuote === quoteIndex && cItem.partId.includes("countertop"))
    : cartItems.filter(cItem => cItem.partId.includes("countertop"));

  const cartItem = addedCountertops[0];

  if (!cartItem) {
    return null
  }

  const featuresCollectionsList = getFeaturesCollectionsList(cartItem, fabricatorData, filterGroups);
  if (!featuresCollectionsList || !featuresCollectionsList.length) {
    return null
  }

  const totalCountertopsQuantity = addedCountertops.reduce(((accumulator, cItem) => accumulator + cItem.quantity), 0);

  return (
    <View style={styles.cartItemSimilar} wrap={true}>
      <Text style={insideQuote ? [styles.cartItemSimilarTitle, styles.cartItemSimilarTitlePadding] : styles.cartItemSimilarTitle}>
        {printContext.messages["similar.title"]}
      </Text>
      <View style={styles.cartItemSimilarContent}>
        <View style={styles.cartItemSimilarContentCell} />
        <View style={styles.cartItemSimilarContentCell}>
          <View style={[styles.cartItemSimilarItem, styles.cartItemSimilarItemNoBorder]} wrap={false}>
            <View style={styles.cartItemSimilarItemBlock}>
              <Text style={styles.cartItemSimilarItemLabel}>{printContext.messages["similar.filterName"]}</Text>
            </View>
            <View style={styles.cartItemSimilarItemBlock}>
              <Text style={styles.cartItemSimilarItemLabel}>{printContext.messages["similar.product.priceProject"]}</Text>
            </View>
          </View>
          {similarOpened ? featuresCollectionsList.map((featureCollection, featureCollectionIndex) => {
            return <PrintSimilarProductsListItem key={featureCollection.id}
                                                 fabricatorData={fabricatorData}
                                                 cartItem={cartItem}
                                                 addedCountertops={addedCountertops}
                                                 totalCountertopsQuantity={totalCountertopsQuantity}
                                                 locale={locale}
                                                 filterGroups={filterGroups}
                                                 quoteIndex={quoteIndex}
                                                 lastItem={featureCollectionIndex === featuresCollectionsList.length - 1}
                                                 featureCollection={featureCollection}
                                                 styles={styles}/>
          }) : null}
        </View>
      </View>
    </View>
  )
};

PrintSimilarProducts.propTypes = {
  quoteIndex: PropTypes.number,
  cartItems: PropTypes.array.isRequired,
  filterGroups: PropTypes.array,
  fabricatorData: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  styles: PropTypes.object.isRequired,
};

export default PrintSimilarProducts
